import MuiTabScrollButton, {
  type TabScrollButtonProps,
} from "@mui/material/TabScrollButton";

export type { TabScrollButtonProps };

export function TabScrollButton(props: TabScrollButtonProps) {
  return <MuiTabScrollButton {...props} />;
}
